module.exports = __webpack_public_path__ + "static/banner-agenda-6d0831b1e6a4de6e3fb4fc168dcf52c4.jpg";